import React from 'react';

interface IIconProps {
  className?: string;
}

const Icon = (props: IIconProps) => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#4468FF"
          strokeWidth="3"
          d="M12 8v11.252M38 8v17.429M25 8v5.626M12 27.903v11.252M38 34.08v5.075M25 22v17.43"
        />
        <rect stroke="#4468FF" strokeWidth="2" x="9" y="19" width="6" height="9" rx="3" />
        <rect stroke="#4468FF" strokeWidth="2" x="22" y="13" width="6" height="9" rx="3" />
        <rect stroke="#4468FF" strokeWidth="2" x="35" y="25" width="6" height="9" rx="3" />
      </g>
    </svg>
  );
};

export default React.memo(Icon);
